export const FETCH__STATEMENT_SCAN_STATUS = 'FETCH__STATEMENT_SCAN_STATUS';
export const FETCH__STATEMENT_SCAN_STATUS__SUCCESS = 'FETCH__STATEMENT_SCAN_STATUS__SUCCESS';
export const FETCH__STATEMENT_SCAN_STATUS__FAIL = 'FETCH__STATEMENT_SCAN_STATUS__FAIL';

export const START__STATEMENTS_SCAN = 'START__STATEMENTS_SCAN';
export const START__STATEMENTS_SCAN__SUCCESS = 'START__STATEMENTS_SCAN__SUCCESS';
export const START__STATEMENTS_SCAN__FAIL = 'START__STATEMENTS_SCAN__FAIL';